import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Icon, Loader } from '@gaiads/telia-react-component-library';

import { Id } from '../../../utils/types';

interface PriceSaveButtonProps {
  bundleId?: Id;
  priceChanged?: boolean;
  onPriceSave: () => void;
  loading: boolean;
}

export function PriceSaveButton(props: PriceSaveButtonProps) {
  const { bundleId, priceChanged, onPriceSave, loading } = props;

  const { t } = useTranslation('productsscreen');
  return (
    <>
      {priceChanged && (
        <Flex centeredHorizontally>
          {loading ? (
            <Loader size="md" data-testid={`price-save-loader-${bundleId}`} />
          ) : (
            <Button clickableAppearance onClick={onPriceSave} title={t('productsTable.savePriceTitle')}>
              <Icon name="checkmark" size="sm" />
            </Button>
          )}
        </Flex>
      )}
    </>
  );
}
